var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngineOffError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 83,
    viewBox: "0 0 90 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 80.1C64.3856 80.1 80.1004 64.3852 80.1004 45C80.1004 25.6148 64.3856 9.90002 45.0004 9.90002C25.6152 9.90002 9.90039 25.6148 9.90039 45C9.90039 64.3852 25.6152 80.1 45.0004 80.1Z",
    fill: "#001236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8193 25.7228H46.118C55.013 25.7228 62.3748 28.9372 62.3748 38.9776C62.3748 49.0181 54.9484 52.8883 46.3397 52.8883H41.5919V66.3649H31.8286V25.7228H31.8193ZM45.8409 45.2033C50.5886 45.2033 52.8886 42.968 52.8886 38.9776C52.8886 34.9873 50.2745 33.4633 45.5822 33.4633H41.6012V45.2033H45.8501H45.8409Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.732 80.2598L70.4881 60.2395C71.1457 59.1202 72.7816 59.1202 73.4391 60.2395L85.1952 80.2598C85.8528 81.387 85.0348 82.8 83.7197 82.8H60.2075C58.8924 82.8 58.0745 81.387 58.732 80.2598Z",
    fill: "#E80000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8574 78.5551C69.8574 77.3815 70.7006 76.4764 71.8707 76.4764C73.0408 76.4764 73.9011 77.3815 73.9011 78.5551C73.9011 79.7286 73.058 80.6509 71.8707 80.6509C70.6834 80.6509 69.8574 79.7217 69.8574 78.5551Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5952 66.276C73.5918 65.3296 72.8243 64.5621 71.8779 64.5621C70.9315 64.5621 70.1641 65.3296 70.1641 66.276L70.7801 74.1088V74.1157C70.7801 74.7248 71.2722 75.2204 71.8848 75.2204C72.4974 75.2204 72.9895 74.7248 72.9895 74.1157V74.1088L73.5986 66.276H73.5952Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.2,
    height: 70.2,
    fill: "white",
    transform: "translate(9.90039 9.90002)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineOffError);
export default __webpack_public_path__ + "static/media/engineOffError.8f05720a00e26696d91dc1f64e33e14e.svg";
export { ForwardRef as ReactComponent };